/**
 * Aura AGM (AUDITED · Sole Member — Individual) preset
 *   (my_preset / sg / aura / agm-sole-indiv) — 자체완결 모듈, 자체등록.
 *
 * 매칭 = task code CAU007 (Aura 접두어 CAU).
 *   priority 59.
 * 배선: sg/aura/index.ts 가 이 모듈을 import 하면 로드 시 자동 등록.
 *
 * agm-sole-corp(CAU004, 법인 단독주주)와 달리 **개인 단독주주**(Audited):
 *   문서 = Letter of Notification & Lodgement of AR · AGM Documents(DRW Audited + Notice of AGM) ·
 *          DDF(이사 이해관계 공시) · Notice for Controller(개인).
 *   법인 특유(Consent to Short Notice / Minutes s.179(6) / 법인 컨트롤러 Notice) 없음 → 더 단순.
 */
import { registerPanel } from '@/features/startTask/preset_task/shared/preset/panels/panelRegistry';
import { registerChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/chatFlowRegistry';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import PreSetAuraAgmSoleIndivPanel from './components/PreSetAuraAgmPanel.vue';
import { auraAgmSoleIndivFlow } from './chatflows/auraAgmFlow';

export { default as PreSetAuraAgmSoleIndivPanel } from './components/PreSetAuraAgmPanel.vue';
export { auraAgmSoleIndivFlow } from './chatflows/auraAgmFlow';

/** 공통코드 — Aura AGM (Audited, Sole Member Individual) 은 CAU007 로 발급됨. */
export const AURA_AGM_SOLE_INDIV_TASK_CODES: string[] = ['CAU007'];

export function matchesAuraAgmSoleIndiv(sel: PreSetSelection): boolean {
  const code = (sel.task.TASK_CODE || '').toUpperCase();
  return AURA_AGM_SOLE_INDIV_TASK_CODES.map((c) => c.toUpperCase()).includes(code);
}

export function registerAuraAgmSoleIndivPreset(): void {
  registerChatFlow(auraAgmSoleIndivFlow);
  registerPanel({
    id: 'aura-agm-sole-indiv',
    priority: 59,
    match: (sel) => matchesAuraAgmSoleIndiv(sel),
    component: PreSetAuraAgmSoleIndivPanel,
    meta: { docType: 'SG_AGM_SOLE_INDIV_PRE', studio: true },
  });
}

registerAuraAgmSoleIndivPreset();
